// extracted by mini-css-extract-plugin
module.exports = {"selectedPlayerText":"_5D8L4foYuGgIgWH6QsmcmQ==","grid":"_91SSHTBNMnWroAH-XyUGCw=="};